import Collapse from "@mui/material/Collapse";
import CardMedia from "@mui/material/CardMedia";
import { useEffect } from "react";
import Box from "@mui/material/Box";

function Payment({ payment, collapseValue, heightDisplay, pelecradUrl }) {
  const iframeSize = heightDisplay - 220;

  useEffect(() => {
    if (payment) {
      collapseValue(false);
    } else {
      collapseValue(true);
    }
  }, [payment]);

  return (
    <Box>
      <Collapse in={payment} timeout={{ enter: 1000, exit: 1000 }}>
        <CardMedia>
          <iframe
            sandbox="allow-top-navigation allow-scripts allow-same-origin"
            id="peleIframe"
            src={pelecradUrl}
            title="Pelecard payment"
            width="100%"
            style={{
              width: "100%",
              height: iframeSize + "px",
              borderRadius: "16px",
            }}
          ></iframe>
        </CardMedia>
      </Collapse>
    </Box>
  );
}

export default Payment;
